<template>
  <DynamicFormHolder
    is-dialog
    :form-name="formName"
    :form-sent-action="formSentAction"
    :steps-after-form="stepsAfterForm"
    :steps-before="stepsBefore"
  />
</template>

<script>
export default {
  name: 'DashboardBloodTestForm',
  data() {
    return {
      formName: 'interpretation-of-results'
    };
  },
  computed: {
    stepsBefore() {
      return [
        {
          cmp: 'BloodTestInfoStep',
          dialogDataStore: 'profile/bloodTestForm'
        }
      ];
    },
    stepsAfterForm() {
      return [
        {
          cmp: 'BloodTestFinalStep',
          dialogDataStore: 'profile/bloodTestForm'
        }
      ];
    }
  },
  methods: {
    formSentAction() {
      this.gtmPush({ event: 'form_sent_success', 'form.name': this.formName });
      this.$store.dispatch('profile/dashboard/setQuestions');
    }
  }
};
</script>
